import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <img src="/assets/logo.png" alt="Tuneza Lodge" className="h-12 mr-3" />
          <span className="text-xl font-semibold text-gray-800">Tuneza Lodge</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <a href="#home" className="text-gray-700 hover:text-gold-600 transition">Home</a>
          <a href="#about" className="text-gray-700 hover:text-gold-600 transition">About</a>
          <a href="#rooms" className="text-gray-700 hover:text-gold-600 transition">Rooms</a>
          <a href="#services" className="text-gray-700 hover:text-gold-600 transition">Services</a>
          <a href="#gallery" className="text-gray-700 hover:text-gold-600 transition">Gallery</a>
          <a href="#contact" className="text-gray-700 hover:text-gold-600 transition">Contact</a>
        </nav>

        {/* Book Now Button */}
        <a
          href="#contact"
          className="hidden md:inline-block bg-gold-500 text-white px-5 py-2 rounded-md hover:bg-gold-600 transition"
        >
          Book Now
        </a>

        {/* Hamburger Icon (mobile) */}
        <button
          className="md:hidden text-gray-700 focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <nav className="flex flex-col items-center py-4 space-y-3">
            <a href="#home" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>Home</a>
            <a href="#about" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>About</a>
            <a href="#rooms" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>Rooms</a>
            <a href="#services" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>Services</a>
            <a href="#gallery" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>Gallery</a>
            <a href="#contact" className="text-gray-700 hover:text-gold-600 transition" onClick={closeMenu}>Contact</a>
            <a href="#contact" className="bg-gold-500 text-white px-5 py-2 rounded-md hover:bg-gold-600 transition w-32 text-center" onClick={closeMenu}>
              Book Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;